module.exports = __webpack_public_path__ + "img/tribune_layout_mobile.22dcba63.png";